<template>
  <div v-if="myData.itemsSalaire === 0 || isEmpty(myData.itemsSalaire)">
    Aucune donnée à afficher.
  </div>
  <div v-else>
    <b-row>
      <b-col sm="7">
        <b-table id="table-salaire" bordered small :items="myData.itemsSalaire" :fields="fields" responsive="sm" :tbody-tr-class="getClassEcartSalaire">
          <template #thead-top="data">
            <b-tr>
              <b-th style="background-color:#dadddf;"><span class="sr-only">Mois</span></b-th>
              <b-th v-if="sourceData === 'cevComplet'" style="background-color:#c1e7f4;text-align:center;"  colspan="4">Salaire Cev</b-th>
              <b-th class="bg-info" v-if="sourceData === 'listing'" style="text-align:center;">Salaire Listing</b-th>
              <b-th style="background-color:#ffeeba;text-align:center;">Salaire DSN</b-th>
              <b-th style="background-color:#fdd6d6;text-align:center;">Salaire retenu</b-th>
            </b-tr>
          </template>
          <template #cell(salaireCev)="row">
              <b-row>
                <b-col :class="getClassEcartSalaire(row.item)">
                  <span style="margin-right:10px;">{{ row.item.salaireCev == '0.00' ? '' : formatNumber(row.item.salaireCev) }}</span>
                  <button class="btn btn-success btn-sm" v-if="row.item.salaireCev != '0.00' && row.item.salaireCev != ''" @click.prevent="setSalaire('cev', row.item)" :disabled="isDisabled()"><i class="fa fa-arrow-right" title="Choisir ce salaire"></i></button>
                </b-col>
              </b-row>
          </template>
          <template #cell(typeSalaireCev)="row"> 
            <b-row>
              <b-col style="text-align:left;">
                <span>{{ row.item.typeSalaireCev }}</span>
              </b-col>
            </b-row>
          </template>
          <template #cell(motif)="row">
            <b-row>
              <b-col style="text-align:left;">
                <span>{{ row.item.motif }}</span>
              </b-col>
            </b-row>
          </template>
          <template #cell(primeCev)="row">
            <b-row>
              <b-col><span>{{ row.item.primeCev }}</span></b-col>
            </b-row>
          </template>
          <template #cell(salaireListing)="row">
            <b-row>
              <b-col :class="getClassEcartSalaire(row.item)">
                <span style="margin-right:10px;">{{ formatNumber(row.item.salaireListing) }}</span>
                <button class="btn btn-success btn-sm" v-if="row.item.salaireListing != '0.00' && row.item.salaireListing != ''" @click.prevent="setSalaire('listing', row.item)" :disabled="isDisabled()"><i class="fa fa-arrow-right" title="Choisir ce salaire"></i></button>
              </b-col>
            </b-row>
          </template>
          <template #cell(salaireDsn)="row">
              <b-row>
                <b-col style="text-align:right" :class="getClassEcartSalaire(row.item)">
                  <span style="margin-right:10px;">{{ formatNumber(row.item.salaireDsn) }}</span>
                  <button class="btn btn-success btn-sm" v-if="row.item.salaireDsn != '0.00' && row.item.salaireDsn != ''" @click.prevent="setSalaire('dsn', row.item)" :disabled="isDisabled()"><i class="fa fa-arrow-right" title="Choisir ce salaire"></i></button>
                </b-col>
              </b-row>
          </template>
          <template #cell(salaireRetenu)="row">
            <b-form-input
                :disabled="isDisabled()"
                type="text"
                class="text-right"
                :ref="'name_salaire_' +row.item.id"
                :value="row.item.salaireRetenu"
                @input="val => onInput(val, row)"
                @blur="completeDecimales(row)"
                @keydown="onlyAllowNumbers"
            />
          </template>
        </b-table>
      </b-col>
      <b-col sm="5">
        <b-card no-body>
          <div class="card-smallHeader card-header-action">
            <span><b>Moyenne et taux de charges</b></span><br>
            <b-form-group style="padding-top:10px">
              <b-row>
                <b-col sm="3"></b-col>
                <b-col sm="3" v-if="this.dossier.canal.libelle_technique === 'cev'"><label style="color:#73818f;margin-left:30px"><i><u>CeV</u></i></label></b-col>
                <b-col sm="3"><label style="color:#73818f;margin-left:30px"><i><u>DSN</u></i></label></b-col>
                <b-col sm="3"><label style="color:#73818f;margin-left:20px"><i><u>Retenu</u></i></label></b-col>
              </b-row>
              <b-row>
                <b-col sm="3"><b>Moyenne Salaire Brut</b></b-col>
                <b-col sm="3" v-if="this.dossier.canal.libelle_technique === 'cev'"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireBrutCev)" id="moyenne_salaire_brut_cev" type="text" :disabled="true" /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireBrutDsn)" id="moyenne_salaire_brut_dsn" type="text" :disabled="true"  /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireBrut)" id="moyenne_salaire_brut" type="text" :disabled="true"  /></b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col sm="3"><b>Moyenne Salaire Net</b></b-col>
                <b-col sm="3" v-if="this.dossier.canal.libelle_technique === 'cev'"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireNetCev)" id="moyenne_salaire_net_cev" type="text" :disabled="true"  /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireNetDsn)" id="moyenne_salaire_net_dsn" type="text" :disabled="true"  /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyenneSalaireNet)" id="moyenne_salaire_net" type="text" :disabled="true" /></b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col sm="3"><b>Moyenne Variable Brut</b></b-col>
                <b-col sm="3" v-if="this.dossier.canal.libelle_technique === 'cev'"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyennePrime)" id="moyenne_prime_brut_cev" type="text" :disabled="true"  /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyennePrime)" id="moyenne_prime_brut_dsn" type="text" :disabled="true"  /></b-col>
                <b-col sm="3"><b-form-input style="margin-left:-2px;" class="text-right"  :value="formatNombre(myData.moyennePrime)" id="moyenne_prime_brut" type="text" :disabled="true"  /></b-col>
              </b-row>
              <b-row class="mt-2" v-if="this.hasModuleTaux">
                <b-col sm="2"></b-col>
                <b-col sm="2"><label style="color:#73818f;margin-left:15px"><i><u>Taux Cev</u></i></label></b-col>
                <b-col sm="2"><label style="color:#73818f;"><i><u>Taux Retenu</u></i></label></b-col>
              </b-row>
              <b-row v-if="this.hasModuleTaux">
                <b-col sm="2"><b>TA/T1</b></b-col>
                <b-col sm="4">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-button class="taux_cev">{{ myData.cev_tauxA }}</b-button>
                    </b-input-group-prepend>
                    <b-form-input id="taux_a" type="text" class="text-right" v-model="myData.taux_a" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                  </b-input-group>
                </b-col>
                <!-- <b-col sm="6">
                  <b-form-group
                    label-for="taux_a"
                    :label-cols="3"
                    :horizontal="true">
                    <template slot="label"><b>TA/T1</b></template>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button class="taux_cev">{{ myData.cev_tauxA }}</b-button>
                      </b-input-group-prepend>
                      <b-form-input id="taux_a" type="text" class="text-right" v-model="myData.taux_a" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
              </b-row>
              <b-row class="mt-1" v-if="this.hasModuleTaux">
                <b-col sm="2"><b>TB/T2</b></b-col>
                <b-col sm="4">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-button class="taux_cev">{{ myData.cev_tauxB }}</b-button>
                    </b-input-group-prepend>
                    <b-form-input id="taux_b" type="text" class="text-right" v-model="myData.taux_b" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                  </b-input-group>
                </b-col>
                <!-- <b-col sm="4">
                  <b-form-group
                    label-for="taux_b"
                    :label-cols="3"
                    :horizontal="true">
                    <template slot="label"><b>TB/T2</b></template>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button class="taux_cev">{{ myData.cev_tauxB }}</b-button>
                      </b-input-group-prepend>
                      <b-form-input id="taux_b" type="text" class="text-right"  v-model="myData.taux_b" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
              </b-row>
              <b-row class="mt-1" v-if="this.hasModuleTaux">
                <b-col sm="2"><b>TC</b></b-col>
                <b-col sm="4">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-button class="taux_cev">{{ myData.cev_tauxC }}</b-button>
                    </b-input-group-prepend>
                    <b-form-input id="taux_c" type="text" class="text-right" v-model="myData.taux_c" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                  </b-input-group>
                </b-col>
                <!-- <b-col sm="4">
                  <b-form-group
                    label-for="taux_c"
                    :label-cols="3"
                    :horizontal="true">
                    <template slot="label"><b>TC</b></template>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button class="taux_cev">{{ myData.cev_tauxC }}</b-button>
                      </b-input-group-prepend>
                      <b-form-input id="taux_c" type="text" class="text-right"  v-model="myData.taux_c" @keyup="updateMoyenneTaux" :disabled="isDisabled()" />
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
              </b-row>
              <b-row class="mt-1" v-if="this.hasModuleTaux">
                <b-col sm="2"><b>Moyenne Taux</b></b-col>
                <b-col sm="4">
                  <b-form-input style="margin-left:-2px;" class="text-right"  v-model="myData.moyenneTauxCharge" id="moyenne_taux" type="text" :disabled="true" />
                </b-col>
              </b-row>
            </b-form-group>
          </div>
        </b-card>
        <b-card no-body class="mt-2">
          <div>
            <b-row class="mt-3 ml-1">
              <b-col sm="7"><span><b>Appliquer le même salaire pour tous les mois</b></span></b-col>
              <b-col sm="3">
                <b-form-input :disabled="isDisabled()"  :formatter="numberFormatter" type="text" class="text-right" v-model="newSalaire" ></b-form-input>
              </b-col>
              <b-col sm="2">
                <button  v-if="!isDisabled()" class="pull-right btn mb-3 btn-primary btn-md mr-3" @click.prevent="applySalaire()">Appliquer</button>
                <button v-else class="pull-right btn mb-3 btn-secondary btn-md mr-3" style="margin-right:10px;" :disabled="isDisabled()">Appliquer</button>
              </b-col>
            </b-row>
          </div>
        </b-card>
        <button v-if="!isDisabled()" class="pull-right btn mb-3 btn-primary btn-md" style="margin-right:10px;" @click.prevent="saveSalaire()">Enregistrer</button>
        <button v-else class="pull-right btn mb-3 btn-secondary btn-md" style="margin-right:10px;" :disabled="isDisabled()">Enregistrer</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { isEmpty } from "@/utils/fileHelper"
  import { formatNumber, replaceDotToComma, replaceCommaToDot, cantEditFicheDC} from "@/utils/communHelper"
  import { hasRule, espaceGestionRules as rulesDC } from "@/utils/rulesHelper"

  export default {
    name: "Salaire",
    data() {
      return {
        isEmpty,
        formatNumber,
        sourceData:'',
        hasModuleTaux : false,
        newSalaire: '',
        myData: {
          salaireRetenu: '',
          itemsSalaire: [],
          arretSalaire: [],
          taux_a: '',
          taux_b: '',
          taux_c: '',
          cev_tauxA: '',
          cev_tauxB: '',
          cev_tauxC: '',
          moyenneSalaireBrut: '',
          moyenneSalaireNet: '',
          moyenneSalaireBrutCev: '',
          moyenneSalaireNetCev: '',
          moyenneSalaireBrutDsn: '',
          moyenneSalaireNetDsn: '',
          moyennePrime: '',
          moyenneTauxCharge: '',
          totalSalaire: '',
          totalSalaireCev: '',
          totalSalaireDsn: '',
          totalPrime: '',
        },
        replaceDotToComma,
        replaceCommaToDot
      }
    },
    props: ['dossier', 'traitements'],
    created(){
      this.getGrilleSalaire();
    },
    mounted() {
      //this.getGrilleSalaire();
      //this.setFields();
      this.$event.on('reload_salaire', () => {
        this.getGrilleSalaire();
      });
    },
    watch: {
      'myData.itemsSalaire': {
        handler() {
          this.updateMoyenneSalaire();
        },
        deep: true
      },
      'taux_a' : {
        handler() {
          this.updateMoyenneSalaire();
        },
        deep: true
      },
      'taux_b' : {
        handler() {
          this.updateMoyenneSalaire();
        },
        deep: true
      },
      'taux_c' : {
        handler() {
          this.updateMoyenneSalaire();
        },
        deep: true
      },
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'salaire', value);
        }, 2000),
        deep: true,
      }
    },
    computed: {
      fields : function(){
        let tab = [];
        tab.push({ key: 'mois', label: 'Mois', variant: 'secondary', tdClass: 'table-salaire-mois', thStyle: {backgroundColor:'#dadddf'}});
        
        if(this.sourceData === 'cevComplet'){
          tab.push(
            { key: 'salaireCev', label: 'Fixe', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'typeSalaireCev', label: 'Type', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'motif', label: 'Motif', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'primeCev', label: 'Variable', variant: 'primary', tdClass: 'text-right', thStyle: { backgroundColor: '#c1e7f4'}}
          )
        };
        
        if(this.sourceData === 'listing'){
          tab.push({ key: 'salaireListing', label: '', variant: 'info', tdClass: 'text-right bg-info', thClass: 'bg-info'});
        };

        tab.push(
          { key: 'salaireDsn', label: '', variant: 'warning', thStyle: {backgroundColor:'#ffeeba'}},
          { key: 'salaireRetenu', label: '', variant: 'danger', editable: true, thStyle: {backgroundColor:'#fdd6d6'}}
        );

        return tab;
      }
    },
    methods: {
      setFields(){
        this.fields.push({ key: 'mois', label: 'Mois', variant: 'secondary', tdClass: 'table-salaire-mois', thStyle: {backgroundColor:'#dadddf'}});
        
        if(this.sourceData === 'cevComplet'){
          this.fields.push(
            { key: 'salaireCev', label: 'Fixe', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'typeSalaireCev', label: 'Type', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'motif', label: 'Motif', variant: 'primary', tdClass: 'text-right', thStyle: {backgroundColor:'#c1e7f4'}},
            { key: 'primeCev', label: 'Variable', variant: 'primary', tdClass: 'text-right', thStyle: { backgroundColor: '#c1e7f4'}}
          )
        };
        
        if(this.sourceData === 'listing'){
          this.fields.push({ key: 'salaireListing', label: '', variant: 'info', tdClass: 'text-right bg-info', thClass: 'bg-info'});
        };

        this.fields.push(
          { key: 'salaireDsn', label: '', variant: 'warning', tdClass: 'text-right', thStyle: {backgroundColor:'#ffeeba'}},
          { key: 'salaireRetenu', label: '', variant: 'secondary', editable: true, tdClass: 'text-right', thStyle: {backgroundColor:'#fdd6d6'}}
        );
        

      },
      getGrilleSalaire() {
        let self = this
        this.$axios
          .get(`/espaceGestion/dossier/grille-salaire/${this.dossier.id}`)
          .then(response => {
            this.myData.arretSalaire = response.data.arretSalaire
            if (this.myData.arretSalaire !== 0) {
              let salaireLignes = response.data.salaireLignes;
              salaireLignes.sort((a,b) => b.annee.localeCompare(a.annee) || b.moisNumber - a.moisNumber);
              this.myData.itemsSalaire = [];
              for (let sl of salaireLignes) {
                sl.salaireRetenu = formatNumber(sl.salaireRetenu);
                this.myData.itemsSalaire.push(sl);
              }
              // this.myData.itemsSalaire = salaireLignes
              if (!isEmpty(response.data.dossierSalaire)) {
                this.myData.taux_a = replaceDotToComma(response.data.dossierSalaire.taux_a)
                this.myData.taux_b = replaceDotToComma(response.data.dossierSalaire.taux_b)
                this.myData.taux_c = replaceDotToComma(response.data.dossierSalaire.taux_c)
              } else if (!isEmpty(response.data.arretSalaire)) {
                this.myData.taux_a = replaceDotToComma(response.data.arretSalaire.taux_a)
                this.myData.taux_b = replaceDotToComma(response.data.arretSalaire.taux_b)
                this.myData.taux_c = replaceDotToComma(response.data.arretSalaire.taux_c)
                this.myData.cev_tauxA = replaceDotToComma(response.data.arretSalaire.taux_a)
                this.myData.cev_tauxB = replaceDotToComma(response.data.arretSalaire.taux_b)
                this.myData.cev_tauxC = replaceDotToComma(response.data.arretSalaire.taux_c)
              }
              
              //this.myData.moyenneSalaireBrut = response.data.moyenneSalaireBrut
              //this.myData.moyennePrime = response.data.moyennePrime
              this.myData.moyenneTauxCharge = response.data.moyenneTauxCharge
              this.sourceData =  response.data.sourceData
              this.hasModuleTaux = response.data.hasModuleTaux

              let totalPrime = 0
              length = this.myData.itemsSalaire.length

              for (var i = 0; i < length; i++) {
                if (this.myData.itemsSalaire[i].primeCev != '') {
                  totalPrime += parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].primeCev))
                }
              }
              this.myData.totalPrime = totalPrime;
            }
            this.$event.emit('stopLoadingSalaire');

          })
          .catch((error) => {
            console.log(error.message)
            self.$event.emit('stopLoadingSalaire');
            let errorText = error.message
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération des informations salaire DSN (API Mutex), si le problème persiste merci de faire un ticket au support DOSI.',
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      setSalaire(type, item) {
        let refName = 'name_salaire_'+item.id
        if (type === 'cev') {
          item.salaireRetenu = item.salaireCev
          this.$refs[refName].focus();
          // this.updateMoyenneSalaire(item)
        }
        if (type === 'dsn') {
          item.salaireRetenu = item.salaireDsn
          this.$refs[refName].focus();
          // this.updateMoyenneSalaire(item)
        }
        if (type === 'listing') {
          item.salaireRetenu = item.salaireListing
          this.$refs[refName].focus();
        }
        this.updateMoyenneSalaire();
      },
      updateMoyenneTaux() {
        let tauxA = 0;
        let tauxB = 0;
        let tauxC = 0;
        let total = 0;
        let nbTaux = 0;
        if (!isEmpty(this.myData.taux_a)) {
          tauxA = replaceCommaToDot(this.myData.taux_a);
          nbTaux++;
        }
        if (!isEmpty(this.myData.taux_b)) {
          tauxB = replaceCommaToDot(this.myData.taux_b);
          nbTaux++;
        }
        if (!isEmpty(this.myData.taux_c)) {
          tauxC = replaceCommaToDot(this.myData.taux_c);
          nbTaux++;
        }
        total = parseFloat(tauxA) + parseFloat(tauxB) + parseFloat(tauxC)
        this.myData.moyenneTauxCharge = parseFloat(total / nbTaux).toFixed(2)

        this.updateMoyenneSalaire();
      },
      updateMoyenneSalaire() {
        let total = 0;
        let totalCev = 0;
        let totalDsn = 0;
        let length = this.myData.itemsSalaire.length;
        let realLength = 0;
        let realLengthCev = 0;
        let realLengthDsn = 0;
        let seuilTA = 3666;
        let seuilTB = 14664;
        let moyenneSalaireBrutTA = 0;
        let moyenneSalaireBrutTB = 0;
        let moyenneSalaireBrutTC = 0;
        let moyenneSalaireBrutCevTA = 0;
        let moyenneSalaireBrutCevTB = 0;
        let moyenneSalaireBrutCevTC = 0;
        let moyenneSalaireBrutDsnTA = 0;
        let moyenneSalaireBrutDsnTB = 0;
        let moyenneSalaireBrutDsnTC = 0;


        for (var i = 0; i < length; i++) {
          if(this.myData.itemsSalaire[i].salaireRetenu != '' && isNaN(parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireRetenu.replaceAll(/ /g, ''))))){  
            this.myData.itemsSalaire[i].salaireRetenu = null;
          }
          if (this.myData.itemsSalaire[i].salaireRetenu != '' && !isNaN(parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireRetenu.replaceAll(/ /g, ''))))) {
            realLength++;
            total += parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireRetenu.replaceAll(/ /g, '')));
            total = parseFloat(total.toFixed(2));
          }
          if (this.myData.itemsSalaire[i].salaireCev!= ''  && !isNaN(parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireCev)))) {
            realLengthCev++;
            totalCev += parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireCev));
          }
          if (this.myData.itemsSalaire[i].salaireDsn!= '' && !isNaN(parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireDsn)))) {
            realLengthDsn++;
            totalDsn += parseFloat(replaceCommaToDot(this.myData.itemsSalaire[i].salaireDsn));
          }
        }

        if(realLength > 0){
          this.myData.totalSalaire = total;
          this.myData.totalSalaireCev = totalCev;
          this.myData.moyenneSalaireBrut = replaceDotToComma(parseFloat(total / realLength).toFixed(2))
          this.myData.moyenneSalaireBrutCev = realLengthCev > 0 ? replaceDotToComma(parseFloat(totalCev / realLengthCev).toFixed(2)) : '0,00';
          this.myData.moyenneSalaireBrutDsn = realLengthDsn > 0 ? replaceDotToComma(parseFloat(totalDsn / realLengthDsn).toFixed(2)) : '0,00';

          if(replaceCommaToDot(this.myData.moyenneSalaireBrut) <= seuilTA){
            moyenneSalaireBrutTA = replaceCommaToDot(this.myData.moyenneSalaireBrut)
          }else{
            moyenneSalaireBrutTA = seuilTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrut) <= seuilTB){
            moyenneSalaireBrutTB = replaceCommaToDot(this.myData.moyenneSalaireBrut) - moyenneSalaireBrutTA;
          }else{
            moyenneSalaireBrutTB = moyenneSalaireBrutTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrut) > seuilTB){
            moyenneSalaireBrutTC = replaceCommaToDot(this.myData.moyenneSalaireBrut) - moyenneSalaireBrutTA - moyenneSalaireBrutTB;
          }
          
          let salaireNetTA = moyenneSalaireBrutTA - (moyenneSalaireBrutTA * replaceCommaToDot(this.myData.taux_a) / 100);
          let salaireNetTB = moyenneSalaireBrutTB - (moyenneSalaireBrutTB * replaceCommaToDot(this.myData.taux_b) / 100);
          let salaireNetTC = moyenneSalaireBrutTC - (moyenneSalaireBrutTC * replaceCommaToDot(this.myData.taux_c) / 100);

          this.myData.moyenneSalaireNet = replaceDotToComma(parseFloat(salaireNetTA + salaireNetTB + salaireNetTC).toFixed(2))

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutCev) <= seuilTA){
            moyenneSalaireBrutCevTA = replaceCommaToDot(this.myData.moyenneSalaireBrutCev);
          }else{
            moyenneSalaireBrutCevTA = seuilTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutCev) <= seuilTB){
            moyenneSalaireBrutCevTB = replaceCommaToDot(this.myData.moyenneSalaireBrutCev) - moyenneSalaireBrutCevTA;
          }else{
            moyenneSalaireBrutCevTB = moyenneSalaireBrutCevTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutCev) > seuilTB){
            moyenneSalaireBrutCevTC = replaceCommaToDot(this.myData.moyenneSalaireBrutCev) - moyenneSalaireBrutCevTA - moyenneSalaireBrutCevTB;
          }
          
          let salaireNetCevTA = moyenneSalaireBrutCevTA - (moyenneSalaireBrutCevTA * replaceCommaToDot(this.myData.taux_a) / 100);
          let salaireNetCevTB = moyenneSalaireBrutCevTB - (moyenneSalaireBrutCevTB * replaceCommaToDot(this.myData.taux_b) / 100);
          let salaireNetCevTC = moyenneSalaireBrutCevTC - (moyenneSalaireBrutCevTC * replaceCommaToDot(this.myData.taux_c) / 100);
          this.myData.moyenneSalaireNetCev = replaceDotToComma(parseFloat(salaireNetCevTA + salaireNetCevTB + salaireNetCevTC).toFixed(2))

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutDsn) <= seuilTA){
            moyenneSalaireBrutDsnTA = replaceCommaToDot(this.myData.moyenneSalaireBrutDsn);
          }else{
            moyenneSalaireBrutDsnTA = seuilTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutDsn) <= seuilTB){
            moyenneSalaireBrutDsnTB = replaceCommaToDot(this.myData.moyenneSalaireBrutDsn) - moyenneSalaireBrutDsnTA;
          }else{
            moyenneSalaireBrutDsnTB = moyenneSalaireBrutCevTA;
          }

          if(replaceCommaToDot(this.myData.moyenneSalaireBrutDsn) > seuilTB){
            moyenneSalaireBrutDsnTC = replaceCommaToDot(this.myData.moyenneSalaireBrutDsn) - moyenneSalaireBrutDsnTA - moyenneSalaireBrutDsnTB;
          }
          
          let salaireNetDsnTA = moyenneSalaireBrutDsnTA - (moyenneSalaireBrutDsnTA * replaceCommaToDot(this.myData.taux_a) / 100);
          let salaireNetDsnTB = moyenneSalaireBrutDsnTB - (moyenneSalaireBrutDsnTB * replaceCommaToDot(this.myData.taux_b) / 100);
          let salaireNetDsnTC = moyenneSalaireBrutDsnTC - (moyenneSalaireBrutDsnTC * replaceCommaToDot(this.myData.taux_c) / 100);
          this.myData.moyenneSalaireNetDsn = replaceDotToComma(parseFloat(salaireNetDsnTA + salaireNetDsnTB + salaireNetDsnTC).toFixed(2))

       }

      },
      saveSalaire() {
        // console.log('this.itemsSalaire', this.itemsSalaire)
        let self = this

        // let totalSalaire = 0
        // let totalPrime = 0
        // length = this.itemsSalaire.length

        // // for (var i = 0; i < length; i++) {
        // //   if (this.itemsSalaire[i].salaireRetenu != '') {
        // //     totalSalaire += parseFloat(replaceCommaToDot(this.itemsSalaire[i].salaireRetenu))
        // //   }
        // // }
        // for (var i = 0; i < length; i++) {
        //   if (this.itemsSalaire[i].primeCev != '') {
        //     totalPrime += parseFloat(replaceCommaToDot(this.itemsSalaire[i].primeCev))
        //   }
        // }
        // this.myData.totalPrime = totalPrime;
          let error = false;
        this.myData.itemsSalaire.forEach(function (element){
          element.salaireRetenu = element.salaireRetenu.replaceAll(/ /g, '');
          if(isNaN(parseFloat(replaceCommaToDot(element.salaireRetenu))) && !isEmpty(element.salaireRetenu)){
            self.$swal({
              position: "top",
              type: "error",
              title: "Erreur de salaire",
              text: "Veuillez vérifier le format des montants",
              showConfirmButton: false,
              timer: 5000
            });
            error = true;
          }
        });

        if(error === true){
            return false;
        }
        let dataPost = {}
        // pour la table dossier_salaire
        dataPost.itemsSalaire = this.myData.itemsSalaire

        //for each ()
        // pour la table dossier_salaire_moyenne
        dataPost.totalSalaire = replaceDotToComma(this.myData.totalSalaire)
        dataPost.moyenneSalaireBrut = replaceDotToComma(this.myData.moyenneSalaireBrut)
        dataPost.totalPrime = replaceDotToComma(this.myData.totalPrime) ? replaceDotToComma(this.myData.totalPrime) : 0
        dataPost.moyennePrime = replaceDotToComma(this.myData.moyennePrime) ? replaceDotToComma(this.myData.moyennePrime) : 0
        dataPost.taux_a = replaceDotToComma(this.myData.taux_a)
        dataPost.taux_b = replaceDotToComma(this.myData.taux_b)
        dataPost.taux_c = replaceDotToComma(this.myData.taux_c)
        dataPost.moyenneTauxCharge = replaceDotToComma(this.myData.moyenneTauxCharge)

        this.$store.commit('IS_LOADING', true);
        this.$axios.post(`/espaceGestion/dossier/grille-salaire/save/${this.dossier.id}`, dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: "La grille de salaire a bien été modifiée",
              showConfirmButton: false,
              timer: 5000
            });
            this.getGrilleSalaire();
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
            self.getGrilleSalaire();
          });
      },
      isDisabled() {
        let statusDossier = this.dossier.status.find( status => status.pivot.traitement_id === parseInt(this.$route.query.traitementId,10));
        return cantEditFicheDC(this.dossier) || isEmpty(statusDossier) || statusDossier.libelle_technique.startsWith('traite_') ? true : false;
      },
      numberFormatter(value) {
        return formatNumber(value);
      },
      getClassEcartSalaire(item){ 
        //return 'incoherenceSalaire';
        //if(item !== undefined){
          //console.log('item.salaireDsn',item.salaireDsn);
          if(item.salaireDsn != '0.00' && item.salaireDsn != ''){
            if(item.salaireListing != '0.00' && item.salaireListing != ''){
              if(item.salaireDsn !== item.salaireListing ){
                return 'incoherenceSalaire';
              }
            }else if(item.salaireCev != '0.00' && item.salaireCev != ''){
              if(item.salaireDsn !== item.salaireCev ){
                return 'incoherenceSalaire';
              }
            }
          }
        //}
        return '';
      },
      applySalaire(){
        if(this.newSalaire !== ''){
          this.myData.itemsSalaire.map( salaire => salaire.salaireRetenu = this.newSalaire)
          this.newSalaire = '';
        }
      },
      cantEditFicheDC,
      // Cette méthode formate UNIQUEMENT les valeurs en lecture seule (moyennes)
      formatNombre(value) {
        if (!value && value !== 0) return '';
        
        // Convertir en string et gérer les nombres avec point ou virgule
        let strValue = String(value);
        
        // Séparer partie entière et décimale (gérer . et ,)
        let parts = strValue.includes(',') ? strValue.split(',') : strValue.split('.');

        // Nettoyer la partie entière : garder que les chiffres
        let intPart = parts[0].replace(/\D/g, '');
        if (!intPart) intPart = '0';

        // Ajouter les espaces tous les 3 chiffres dans la partie entière
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        // Partie décimale : garder que les chiffres, si elle existe
        let decimalPart = parts[1] ? parts[1].replace(/\D/g, '') : '';
        
        // Si on a des décimales, les formater avec 2 chiffres
        if (decimalPart) {
          // Compléter avec un 0 si une seule décimale
          if (decimalPart.length === 1) {
            decimalPart = decimalPart + '0';
          } else if (decimalPart.length > 2) {
            decimalPart = decimalPart.substring(0, 2);
          }
          return intPart + ',' + decimalPart;
        }
        
        // Retourner avec ,00 pour les valeurs entières (moyennes calculées)
        return intPart + ',00';
      },
      onInput(value, row) {
        // Remplacer les points par des virgules
        let replaced = value.replace(/\./g, ',');

        // Nettoyer la saisie : autoriser chiffres et une seule virgule
        let cleaned = replaced.replace(/[^0-9,]/g, '');

        // Empêcher plusieurs virgules
        let parts = cleaned.split(',');
        if (parts.length > 2) {
          cleaned = parts.shift() + ',' + parts.join('');
        }

        // Limiter à 2 décimales après la virgule
        if (parts.length === 2 && parts[1].length > 2) {
          cleaned = parts[0] + ',' + parts[1].substring(0, 2);
        }

        // Formater avec espaces pour les milliers (partie entière uniquement)
        let partsFormatted = cleaned.split(',');
        let intPart = partsFormatted[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        cleaned = partsFormatted.length === 2 ? intPart + ',' + partsFormatted[1] : intPart;

        // Met à jour la donnée brute
        this.$set(row.item, 'salaireRetenu', cleaned);
      },
      completeDecimales(row) {
        // Quand on quitte le champ, compléter les décimales manquantes
        let value = row.item.salaireRetenu;
        if (!value) return;

        // Enlever les espaces pour traiter la valeur
        let cleanValue = value.replace(/\s/g, '');
        
        // Si pas de virgule, ajouter ,00
        if (!cleanValue.includes(',')) {
          cleanValue = cleanValue + ',00';
        } else {
          // Si virgule présente, vérifier les décimales
          let parts = cleanValue.split(',');
          if (parts[1] === undefined || parts[1] === '') {
            // Virgule seule sans décimales : ajouter 00
            cleanValue = parts[0] + ',00';
          } else if (parts[1].length === 1) {
            // Une seule décimale : ajouter un 0
            cleanValue = parts[0] + ',' + parts[1] + '0';
          }
        }

        // Reformater avec espaces pour les milliers
        let finalParts = cleanValue.split(',');
        let intPart = finalParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        let formatted = intPart + ',' + finalParts[1];

        // Mettre à jour la valeur
        this.$set(row.item, 'salaireRetenu', formatted);
      },
      onlyAllowNumbers(event) {
        const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];

        // Autoriser chiffres (0-9), point, virgule
        const isNumber = /^[0-9]$/.test(event.key);
        const isDecimalSeparator = event.key === ',' || event.key === '.';

        // Vérifie qu'on ne tape pas une deuxième virgule ou point
        const alreadyHasSeparator = event.target.value.includes(',') || event.target.value.includes('.');

        if (isNumber || allowedKeys.includes(event.key) || (isDecimalSeparator && !alreadyHasSeparator)) {
          return; // autorisé
        }

        event.preventDefault(); // sinon, bloquer
      }
      // Fin HMESS-215
    }
  }
</script>

<style scoped>
  table#table-salaire thead th {
    background-color:'';
  }

  table#table-salaire td.table-salaire-mois{
    font-weight: 500;
  }

  table#table-salaire .btn-success.disabled {
    background-color: #8ddfaa;
    border-color: #8ddfaa;
  }

  .taux_cev {
    width: 70px;
    cursor: text;
    pointer-events: none;
  }

  .incoherenceSalaire{
    color:red;
    font-weight:bold;
    text-decoration:underline;
  }


</style>
